import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import * as validators from 'utils/validators';
import InputField from './InputField';
import Dialog from './Dialog';
import DateTimeField from 'components/DateTimeField';

class SelectDateDialog extends Dialog {
    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, pristine, reset, submitting, dialogTitle, closeButtonLabel, submitButtonLabel, onOk, isValidDate, defaultValue } = this.props;

        let show = this.state.show;

        return (

            <Modal backdrop="static" enforceFocus={true} show={show || false} onHide={this.hide} dialogClassName="date-picker-modal">
                <style dangerouslySetInnerHTML={{__html: `.date-picker-modal .modal-dialog { width: 400px; } .date-picker-modal .modal-content { overflow: visible; } .date-picker-modal .modal-body { overflow: visible; }`}} />
                <form onSubmit={handleSubmit(onOk)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{dialogTitle}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Field
                            className="form-control"
                            name="date"
                            defaultValue={defaultValue ? new Date(defaultValue) : new Date()}
                            isValidDate={isValidDate}
                            component={DateTimeField}
                            validate={[validators.required]}
                        />

                    </Modal.Body>

                    <Modal.Footer>
                        <Button type="button" onClick={this.hide}>{closeButtonLabel}</Button>
                        <Button type="submit" disabled={submitting} bsStyle="primary">{submitButtonLabel}</Button>
                    </Modal.Footer>

                </form>
            </Modal>

        );
    }
}


SelectDateDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    closeButtonLabel: PropTypes.string.isRequired,
    submitButtonLabel: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired
}

export default reduxForm({ form: "SelectDateDialog" })(SelectDateDialog);



// WEBPACK FOOTER //
// app/components/SelectDateDialog.jsx